var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.articles,"item-key":"key","sort-by":"pos","group-by":"pos","show-group-by":"","items-per-page":-1,"hide-default-footer":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }